export default __webpack_public_path__ + "static/PromptIconThirteen-69bd1cc6fe2664a002f9847573743184.png";